var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',[_c('q-btn',{staticClass:"full-width q-mb-md",attrs:{"label":_vm.$t('checkout_to_mollie_payment'),"color":"primary"},on:{"click":_vm.goToMollieCheckout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }